import Vue from 'vue';
import Router from 'vue-router';
import Banner from '@/components/Banner.vue';
import DashBanner from '@/components/DashBanner.vue';
import Signup from '@/components/Signup.vue';
import Login from '@/components/Login.vue';
import LoginUniversalEntryPoint from '@/components/Login/v2/LoginUniversalEntryPoint.vue';
import LoginForm from '@/components/Login/v2/LoginForm.vue';
import Findjobs from '@/components/Findjobs.vue';
import Verification from '@/components/Verification.vue';
import RetrieveOldEmailConfirmation from './components/Registration/RetrieveOldEmailConfirmation.vue';
import RetrievedEmailVerification from './components/Registration/RetrievedEmailVerification.vue';
import AppRetrieveOldEmailConfirmation from './components/Registration/AppRetrieveOldEmailConfirmation.vue';
import AppRetrievedEmailVerification from './components/Registration/AppRetrievedEmailVerification.vue';
import RetrievedEmailSignupPreference from './components/Registration/RetrievedEmailSignupPreference.vue';
import AppRetrievedEmailSignupPreference from './components/Registration/AppRetrievedEmailSignupPreference.vue';
import Invite from '@/components/Invite.vue';
import Jobdetails from '@/components/Jobdetails.vue';
import Referrals from '@/components/Referrals.vue';
import Myprofile from '@/components/Myprofile.vue';
import MyprofileAccordian from '@/components/MyprofileAccordian.vue';
import NotificationPreference from '@/components/MyProfile/NotificationPreference.vue';
import MyProfileDetails from '@/components/MyProfileDetails.vue';
import UpdatePassword from '@/components/MyProfile/UpdatePassword.vue';
import MyProfileDetailsNew from '@/components/MyProfileDetailsNew.vue';
import EducationHistory from '@/components/Commons/EducationHistory.vue';
import WorkPreference from '@/components/MyProfile/WorkPreference.vue';
import ProfessionalReference from './components/GuidedSignup/ProfessionalReference.vue';
import Language from './components/MyProfile/Language.vue';
import PassportDetails from './components/GuidedSignup/PassportDetails.vue';
import LicenceDetails from './components/GuidedSignup/LicenceDetails.vue';
import AppReferral from '@/components/AppReferral.vue';
import CompanyReferral from '@/components/CompanyReferral.vue';
import ChangePassword from '@/components/ChangePassword.vue';
import ChangePasswordV2 from '@/components/Login/v2/ChangePassword.vue';
import ForgotPassword from '@/components/ForgotPassword.vue';
import ForgotPasswordForm from '@/components/Login/v2/ForgotPasswordForm.vue';
import OTPLogin from '@/components/Login/v2/OTPLogin.vue';
import OTPLoginSuccess from '@/components/Login/v2/OTPLoginSuccess.vue';
import Joblisting from '@/components/Joblisting.vue';
import ReferralListing from '@/components/ReferralListing.vue';
// import JobHistory from '@/components/JobHistory.vue';
import MyJobStatus from '@/components/MyJobs/JobStatus/MyJobStatus.vue';
// import Skills from '@/components/Skills.vue';
// import Resumes from '@/components/Resumes.vue';
import ResumeUpload from '@/components/ResumeUpload.vue';
import Questionnaire from '@/components/Questionnaire.vue';
import SupportingDocuments from '@/components/SupportingDocuments.vue';
import CompanyProfile from '@/components/CompanyProfile.vue';
import JobShare from '@/components/JobShare.vue';
import QuickSignup from '@/components/QuickSignup.vue';
import ThankYouQuickRegister from '@/components/ThankYouQuickRegister.vue';
import JobApplicationSuccess from '@/components/JobApplicationSuccess.vue';
import ReferAFriend from '@/components/ReferAFriend.vue';
import AnonReferAFriend from '@/components/AnonReferAFriend.vue';
import AnonReferInternalFriend from '@/components/AnonInternalReferAFriend.vue';
import ReferInternalFriend from '@/components/ReferInternalFriend.vue';
import AppSignup from '@/components/AppSignup.vue';
import AppVerification from '@/components/AppVerification.vue';
import WLReferralMain from '@/components/WLReferralMain.vue';
import JobAlertValidation from '@/components/JobAlertValidation.vue';
import JobAlertDeactivation from '@/components/JobAlertDeactivation.vue';
import AppShare from '@/components/AppShare.vue';
import SurveyQuestionnaire from '@/components/SurveyQuestionnaire.vue';
import ThankYou from '@/components/ThankYou.vue';
import Notification from '@/components/Notification.vue';
import MyReferralsList from '@/components/MyReferralsList.vue';
import TroubleLogin from '@/components/TroubleLogin.vue';
import Savedjobs from '@/components/Savedjobs.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import SurveyLanding from '@/components/Survey/SurveyLanding/SurveyLanding.vue';
import SurveyPage from '@/components/Survey/SurveyDetails/SurveyPage.vue';
import SignupOld from '@/components/SignupOld.vue';
import ForgotPasswordOld from '@/components/ForgotPasswordOld.vue';
import VerificationOld from '@/components/VerificationOld.vue';
import AccountLocked from '@/components/Login/v2/AccountLocked.vue';
import JobAlertPage from '@/components/JobAlert/JobAlertPage.vue';
import JobAlertPageV2 from '@/components/JobAlert/JobAlertPageV2.vue';
import Inbox from '@/components/Inbox/Inbox.vue'
import DeActivateJobAlert from '@/components/JobAlert/DeActivateJobAlert.vue';
import DeActivateAllJobAlerts from '@/components/JobAlert/DeActivateAllJobAlerts.vue';
import Help from '@/components/Help.vue';
import ErrorMessage from '@/components/Commons/ErrorMessage.vue';
import GuidedSignup from '@/components/GuidedSignup/Wrapper.vue';
import GuidedSignupV2 from '@/components/GuidedSignup/WrapperV2.vue';
import JobHistoryDetails from '@/components/JobHistoryDetails.vue';
import NewJobHistoryDetails from '@/components/NewJobHistoryDetails.vue';
import SkillsDetails from '@/components/SkillsDetails.vue';
import ResumeDetails from '@/components/ResumeDetails.vue';
import Home from '@/components/Home.vue';
import Forum from '@/components/Forum/Main.vue';
import ChatLanding from '@/components/chat/landing/ChatLanding.vue';
import PostDetails from '@/components/Forum/PostDetails.vue';
import ConfirmEmailAddrress from '@/components/Commons/ConfirmEmailAddrress.vue';
import ConfirmPhoneNumber from '@/components/Commons/ConfirmPhoneNumber.vue';
import MyJobIntermediateStep from '@/components/JobApplicationIntermediateSteps/MyJobIntermediateStep.vue';
import SkillCheckList from '@/components/Commons/SkillCheckList.vue';
import RoleRegisterList from '@/components/JobRoleSignup/RoleRegisterList.vue';
import PilotSignup from '@/components/JobRoleSignup/PilotSignup.vue';
import EngineerSignup from '@/components/JobRoleSignup/EngineerSignup.vue';
import OtherSignup from '@/components/JobRoleSignup/OtherSignup.vue';
import AdditionalDocuments from '@/components/MyProfile/AdditionalDocuments.vue';
import MyDocuments from '@/components/MyProfile/MyDocuments.vue';
import Unsubscribe from '@/components/Commons/Unsubscribe.vue';
import Timesheet from '@/components/timesheet/Main.vue';
import SocialProfiles from '@/components/MyProfile/SocialProfiles.vue';
import ProtectedInformation from '@/components/MyProfile/ProtectedInformation.vue';
import CategoryDetails from '@/components/CategoryDetails.vue';
import DataPrivacySettings from '@/components/DataPrivacySettings.vue';
import AccountDisabled from '@/components/Registration/AccountDisabled.vue';
import QuickApplyJobdetails from '@/components/QuickApply/QuickApplyJobdetails.vue';
import AnonJobApplicationSuccess from '@/components/QuickApply/AnonJobApplicationSuccess.vue';
import OnBoarding from '@/components/EssiumIntegration/OnBoarding.vue';
import TargetRecruitTimesheet from '@/components/TargetRecruitIntegration/TargetRecruitTimesheet.vue';
import {
  faBell,
  faBellSlash,
  faCity,
  faBuilding,
  faCoffee,
  faUserTie,
  faUserPlus,
  faEye,
  faSignInAlt,
  faQuestion,
  faLink,
  faSearchLocation,
  faCaretDown,
  faCircle,
  faUserGraduate,
  faArrowCircleRight,
  faCalendar,
  faFolder,
  faFile,
  faBox,
  faFileWord,
  faArrowRight,
  faFileUpload,
  faCaretLeft,
  faCaretRight,
  faFastForward,
  faFastBackward,
  faStepForward,
  faStepBackward,
  faCheckCircle,
  faCertificate,
  faLongArrowAltRight,
  faHandPointRight,
  faUpload,
  faSearch,
  faSave,
  faCaretUp,
  faEdit,
  faTrashAlt,
  faCheckSquare,
  faPlusCircle,
  faCamera,
  faClock,
  faMapMarkerAlt,
  faTrash,
  faPen,
  faFileAlt,
  faAngleUp,
  faAngleDown,
  faCheck,
  faTimes,
  faAngleRight,
  faEyeSlash,
  faDownload,
  faChevronRight,
  faPauseCircle,
  faEnvelope,
  faPlayCircle,
  faComment,
  faSlidersH,
  faPaperclip,
  faInfoCircle,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from '@fortawesome/vue-fontawesome';
import { vxm } from './store.vuex';
import { Survey } from './models/candidatesurvey/candidatesurveyresponse';
library.add(
  faBell,
  faBellSlash,
  faBuilding,
  faSave,
  faCoffee,
  faLink,
  faUserGraduate,
  faArrowCircleRight,
  faSearch,
  faSearchLocation,
  faEye,
  faFolder,
  faCertificate,
  faCity,
  faFileWord,
  faCheckCircle,
  faHandPointRight,
  faFile,
  faBox,
  faUserTie,
  faUserPlus,
  faCheckSquare,
  faUpload,
  faLongArrowAltRight,
  faArrowRight,
  faSignInAlt,
  faCaretDown,
  faCaretUp,
  faCircle,
  faQuestion,
  faCalendar,
  faEdit,
  faTrashAlt,
  faFileUpload,
  faCaretLeft,
  faCaretRight,
  faStepForward,
  faStepBackward,
  faFastForward,
  faFastBackward,
  faPlusCircle,
  faCamera,
  faClock,
  faMapMarkerAlt,
  faTrash,
  faPen,
  faFileAlt,
  faAngleUp,
  faAngleDown,
  faCheck,
  faTimes,
  faAngleRight,
  faEyeSlash,
  faDownload,
  faChevronRight,
  faPauseCircle,
  faEnvelope,
  faPlayCircle,
  faComment,
  faSlidersH,
  faPaperclip,
  faInfoCircle,
  faUsers
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.use(Router);
declare var window: any;

const gaurd = (to, from, next) => {
  console.log('route', to);
  if (Vue.cookies.get('jwtToken') || window.WorkLLama.jwt || vxm.users.getToken) {
    next();
  } else {
    vxm.users.setRouteAfterLogin(to.name);
    vxm.users.setRouteParamsAfterLogin(to.params);
    next('/login');
  }
};
const gaurdOtp = (to, from, next) => {
  if (Vue.cookies.get('jwtOtpToken')) {
    next();
  } else {
    next('/');
  }
};

const checkLoginRouteGuard = (to, from, next) => {
  const toName = to.name;
  const toQuery = to.query;
  const loginUniversal = 'LoginUniversalEntryPoint';
  const login = 'Login';
  if (toName === loginUniversal || vxm.utility.useLoginSignupV2) {
    console.log('toquery', toQuery);
    toName === loginUniversal
      ? next()
      : next({ name: loginUniversal, query: toQuery });
  } else {
    toName === login ? next() : next({ name: login });
  }
};

const GuidedSignupComponent = window.WorkLLama.isConfigJSONEnabled === 'true'
  ? GuidedSignupV2
  : GuidedSignup;

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: gaurd,
    },
    {
      path: '/onboarding',
      name: 'Onboarding',
      component: OnBoarding,
      beforeEnter: gaurd,
    },
    {
      path: '/target-recruit-timesheet',
      name: 'TargetRecruitTimesheet',
      component: TargetRecruitTimesheet,
      beforeEnter: gaurd,
    },
    {
      path: '/banner',
      name: 'Banner',
      component: Banner,
    },
    {
      path: '/dashbanner',
      name: 'DashBanner',
      component: DashBanner,
    },
    {
      path: '/myprofiledetails',
      name: 'MyProfileDetails',
      component: MyProfileDetails,
      beforeEnter: gaurd,
    },
    {
      path: '/appreferral',
      name: 'AppReferral',
      component: AppReferral,
    },
    {
      path: '/companyreferral',
      name: 'CompanyReferral',
      component: CompanyReferral,
    },
    {
      path: '/change-password',
      name: 'OldChangePassword',
      component: ChangePassword,
      beforeEnter: gaurd,
    },
    {
      path: '/jobApplicationSuccess/:jobId',
      name: 'AnonJobApplicationSuccess',
      component: AnonJobApplicationSuccess,
    },
    {
      path: '/anon-change-password',
      name: 'ChangePassword',
      component: ChangePassword,
    },
    {
      path: '/v2/change-password',
      name: 'ChangePasswordV2',
      component: ChangePasswordV2,
      beforeEnter: gaurdOtp,
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      props: (route) => ({
        email: route.query.email === 'null' ? '' : route.query.email,
      }),
    },
    {
      path: '/otp-login',
      name: 'OTPLogin',
      component: OTPLogin,
    },
    {
      path: '/otp-login-success',
      name: 'OTPLoginSuccess',
      component: OTPLoginSuccess,
      beforeEnter: gaurdOtp,
    },
    {
      path: '/categories/:id/:name',
      name: 'CategoryDetails',
      component: CategoryDetails,
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
    },
    {
      path: '/account-disabled',
      name: 'AccountDisabled',
      component: AccountDisabled,
    },
    {
      path: '/myprofile',
      name: 'Myprofile',
      component: Myprofile,
      beforeEnter: gaurd,
      children: [
        {
          path: '/myprofile/details',
          component: MyProfileDetails,
          name: 'MyProfileDetails',
        },
        {
          path: '/myprofile/jobhistory',
          component: JobHistoryDetails,
          name: 'JobHistoryDetails',
        },
        {
          path: '/myprofile/skills',
          component: SkillsDetails,
          name: 'SkillsDetails',
        },
        {
          path: '/myprofile/resumes',
          component: ResumeDetails,
          name: 'ResumeDetails',
        },
      ],
    },
    {
      path: '/myprofile/v2',
      name: 'MyprofileAccordian',
      component: MyprofileAccordian,
      beforeEnter: gaurd,
      children: [
        {
          path: '/myprofile/v2/details',
          components: {
            details: MyProfileDetailsNew,
          },
          name: 'MyProfileDetailsNew',
        },
        {
          path: '/myprofile/v2/passport',
          components: {
            passport: PassportDetails,
          },
          name: 'PassportDetails',
        },
        {
          path: '/myprofile/v2/licence',
          components: {
            licence: LicenceDetails,
          },
          name: 'LicenceDetails',
        },
        {
          path: '/myprofile/v2/jobhistory',
          components: {
            jobHistory: NewJobHistoryDetails,
          },
          name: 'NewJobHistoryDetails',
        },
        {
          path: '/myprofile/v2/skills',
          components: {
            skills: SkillsDetails,
          },
          name: 'SkillsDetailsV2',
        },
        {
          path: '/myprofile/v2/resumes',
          components: {
            resume: ResumeDetails,
          },
          name: 'ResumeDetailsV2',
        },
        {
          path: '/myprofile/v2/education-history',
          components: {
            educationHistory: EducationHistory,
          },
          name: 'EducationHistory',
        },
        {
          path: '/myprofile/v2/workpreference',
          components: {
            workPreference: WorkPreference,
          },
          name: 'WorkPreference',
        },
        {
          path: '/myprofile/v2/professional-reference',
          components: {
            professionalReference: ProfessionalReference,
          },
          name: 'ProfessionalReference',
        },
        {
          path: '/myprofile/v2/language',
          components: {
            language: Language,
          },
          name: 'Language',
        },
        {
          path: '/myprofile/v2/notification-preference',
          components: {
            notificationPreference: NotificationPreference,
          },
          name: 'NotificationPreference',
        },
        {
          path: '/myprofile/v2/update-password',
          components: {
            updatePassword: UpdatePassword,
          },
          name: 'UpdatePassword',
        },
        {
          path: '/myprofile/v2/additional-documents',
          components: {
            additionalDocuments: AdditionalDocuments,
          },
          name: 'AdditionalDocuments',
        },
        {
          path: '/myprofile/v2/my-documents',
          components: {
            myDocuments: MyDocuments,
          },
          name: 'MyDocuments',
        },
        {
          path: '/myprofile/v2/socialprofiles',
          components: {
            socialprofiles: SocialProfiles,
          },
          name: 'SocialProfiles',
        },
        {
          path: '/myprofile/v2/protectedinformation',
          components: {
            protectedinformation: ProtectedInformation,
          },
          name: 'ProtectedInformation',
        },
        {
          path: '/myprofile/v2/data-privacy-settings',
          components: {
            dataprivacysettings: DataPrivacySettings,
          },
          name: 'DataPrivacySettings',
        },
      ],
    },
    {
      path: '/companyprofile/:Code',
      name: 'CompanyProfile',
      component: CompanyProfile,
    },
    {
      path: '/data-privacy-settings',
      name: 'DataPrivacySetting',
      component: DataPrivacySettings,
    },
    {
      path: '/troublelogin',
      name: 'TroubleLogin',
      component: TroubleLogin,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      props: (route) => ({
        sessionExpired: route.query.sessionExpired ? true : '',
      }),
      beforeEnter: checkLoginRouteGuard,
    },
    {
      path: '/v2/login/:JobID',
      name: 'LoginUniversalEntryPoint',
      component: LoginUniversalEntryPoint,
      props: (route) => ({
        sessionExpired: route.query.sessionExpired ? true : '',
      }),
      beforeEnter: checkLoginRouteGuard,
    },
    {
      path: '/v2/login',
      name: 'LoginUniversalEntryPoint',
      component: LoginUniversalEntryPoint,
      props: (route) => ({
        sessionExpired: route.query.sessionExpired ? true : '',
      }),
      beforeEnter: checkLoginRouteGuard,
    },
    {
      path: '/loginForm',
      name: 'LoginForm',
      component: LoginForm,
      props: (route) => ({
        sessionExpired: route.query.sessionExpired ? true : '',
      }),
    },
    {
      path: '/v2/forgot-password',
      name: 'ForgotPasswordForm',
      component: ForgotPasswordForm,
    },
    {
      path: '/myprofile/v2/skills/checklist',
      component: SkillCheckList,
      name: 'SkillCheckList',
      props: true,
    },
    /* {
      path: "/",
      name: "Login",
      component: Login,
    },*/
    {
      path: '/findjobs',
      name: 'Findjobs',
      component: Findjobs,
    },
    {
      path: '/quickapply/:JobID/:JobSlug*',
      name: 'QuickApplyJobdetailsSlug',
      component: QuickApplyJobdetails,
    },
    {
      path: '/findjobs',
      name: 'Findjobs',
      component: Findjobs,
      props: (route) => ({ jobAlertId: route.query.jobalertid }),
    },
    {
      path: '/jobs-with-skill/:SkillID/:SkillName',
      name: 'FindjobsWithSkill',
      component: Findjobs,
    },
    // {
    //   path: '/jobs-by-industry/:IndustryID/:IndustryName',
    //   name: 'FindjobsByIndustry',
    //   component: Findjobs,
    // },
    {
      path: '/jobs-in-city/:CityId/:CityNameSlug',
      name: 'FindjobsInCity',
      component: Findjobs,
    },
    {
      path: '/jobs-by-filter/:filterUrl',
      name: 'FindjobsByFilter',
      component: Findjobs,
    },
    {
      path: '/jobs-by-industry/:IndustryID/:IndustryName-jobs',
      name: 'JobsByIndustryId',
      component: Findjobs,
    },
    {
      path: '/jobs-by-skill/:SkillID/:SkillName-jobs',
      name: 'JobsBySkillId',
      component: Findjobs,
    },
    {
      path:
        '/jobs-by-industry/location/:IndustryID/:IndustryName-Jobs-in-:location',
      name: 'JobsByIndustryLocation',
      component: Findjobs,
    },
    {
      path: '/jobs-by-skill/location/:SkillID/:SkillName-Jobs-in-:location',
      name: 'JobsBySkillLocation',
      component: Findjobs,
    },
    {
      path: '/jobs-by-location/Jobs-in-:location',
      name: 'JobsByLocation',
      component: Findjobs,
    },
    {
      path: '/quicksignup',
      name: 'QuickSignup',
      component: QuickSignup,
    },
    {
      path: '/submitquicksignup',
      name: 'ThankYouQuickRegister',
      component: ThankYouQuickRegister,
    },
    {
      path: '/jobdetails/:JobID/:JobSlug*',
      name: 'JobdetailsSlug',
      component: Jobdetails,
    },
    {
      path: '/jobdetails/:JobID',
      name: 'Jobdetails',
      component: Jobdetails,
      props: (route) => ({ goBackRoute: route.query.goBackRoute }),
    },
    {
      path: '/referral/:referralCode',
      name: 'WLReferralMain',
      component: WLReferralMain,
    },
    {
      path: '/referral/:referralCode/:referralSlug',
      name: 'WLReferralMainSlug',
      component: WLReferralMain,
    },
    {
      path: '/jobAlert',
      name: 'JobAlert',
      component: JobAlertPage,
      beforeEnter: gaurd,
    },
    {
      path: '/jobAlertV2',
      name: 'JobAlertV2',
      component: JobAlertPageV2,
      beforeEnter: gaurd,
    },
    {
      path: '/inbox',
      name: 'Inbox',
      component: Inbox
    },
    {
      path: '/savedJobs',
      name: 'SavedJobs',
      component: Savedjobs,
      beforeEnter: gaurd,
    },
    {
      path: '/activateJobAlert/:hashCode',
      name: 'JobAlertValidator',
      component: JobAlertValidation,
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
    },
    {
      path: '/deactivateJobAlerts',
      name: 'JobAlertDeactivation',
      component: JobAlertDeactivation,
      props: (route) => ({ code: route.query.code }),
    },
    /* {
      path: "/deactivateJobAlert/:hashCode",
      name: "DeActivateJobAlert",
      component: DeActivateJobAlert,
    },*/
    {
      path: '/deActivateAllJobAlerts/:code',
      name: 'DeActivateAllJobAlerts',
      component: DeActivateAllJobAlerts,
    },
    {
      path: '/joblisting',
      name: 'Joblisting',
      component: Joblisting,
    },
    {
      path: '/referrals',
      name: 'Referrals',
      component: Referrals,
    },
    {
      path: '/referafriend',
      name: 'ReferAFriend',
      component: ReferAFriend,
      beforeEnter: gaurd,
    },
    {
      path: '/anonreferafriend',
      name: 'AnonReferAFriend',
      component: AnonReferAFriend,
    },
    {
      path: '/anonreferinternalfriend',
      name: 'AnonReferInternalFriend',
      component: AnonReferInternalFriend,
    },
    {
      path: '/referinternalfriend',
      name: 'ReferInternalFriend',
      component: ReferInternalFriend,
      beforeEnter: gaurd,
    },
    {
      path: '/referrallisting',
      name: 'ReferralListing',
      component: ReferralListing,
    },
    {
      path: '/verification',
      name: 'Verification',
      component: Verification,
      beforeEnter: gaurd,
    },
    {
      path: '/anonverification',
      name: 'AnonVerification',
      component: Verification,
    },
    {
      path: '/retrieveoldemailconfirmation',
      name: 'RetrieveOldEmailConfirmation',
      component: RetrieveOldEmailConfirmation,
    },
    {
      path: '/retrievedemailverification',
      name: 'RetrievedEmailVerification',
      component: RetrievedEmailVerification,
    },
    {
      path: '/retrievedemailsignuppreference',
      name: 'RetrievedEmailSignupPreference',
      component: RetrievedEmailSignupPreference,
    },
    {
      path: '/appretrievedemailsignuppreference',
      name: 'AppRetrievedEmailSignupPreference',
      component: AppRetrievedEmailSignupPreference,
    },
    {
      path: '/appretrieveoldemailconfirmation',
      name: 'AppRetrieveOldEmailConfirmation',
      component: AppRetrieveOldEmailConfirmation,
    },
    {
      path: '/appretrievedemailverification',
      name: 'AppRetrievedEmailVerification',
      component: AppRetrievedEmailVerification,
    },
    {
      path: '/jobapplicationsuccess/:jobId',
      name: 'JobApplicationSuccess',
      component: JobApplicationSuccess,
      beforeEnter: gaurd,
    },
    {
      path: '/invite',
      name: 'Invite',
      component: Invite,
    },
    {
      path: '/myjobstatus/offered=true/:jobId',
      name: 'myjobstatus',
      component: MyJobStatus,
      beforeEnter: gaurd,
    },
    {
      path: '/myjobstatus',
      name: 'myjobstatus',
      component: MyJobStatus,
      beforeEnter: gaurd,
    },
    {
      path: '/myjobstatus/step/:JobID',
      name: 'myjobstatusWorkflowStep',
      component: MyJobIntermediateStep,
    },
    {
      path: '/jobshare/:JobID',
      name: 'JobShare',
      component: JobShare,
    },
    {
      path: '/guidedsignup',
      name: 'GuidedSignup',
      component: GuidedSignupComponent,
      beforeEnter: gaurd,
      props: true,
    },
    {
      path: '/guidedsignup/skill/checklist',
      component: SkillCheckList,
      name: 'GuidedSignupSkillCheckList',
      props: true,
    },
    {
      path: '/uploadresume/:JobID',
      name: 'ResumeUpload',
      component: ResumeUpload,
      beforeEnter: gaurd,
    },
    {
      path: '/questionnaire/:JobID',
      name: 'Questionnaire',
      component: Questionnaire,
      beforeEnter: gaurd,
    },
    {
      path: '/supportingdocuments/:JobID',
      name: 'SupportingDocuments',
      component: SupportingDocuments,
      beforeEnter: gaurd,
    },
    {
      path: '/appsignup',
      name: 'AppSignup',
      component: AppSignup,
    },
    {
      path: '/registerPage',
      name: 'RegisterPage',
      component: AppSignup,
    },
    {
      path: '/appotpverification',
      name: 'AppVerification',
      component: AppVerification,
    },
    {
      path: '/regSuccess',
    },
    // otpVerification
    {
      path: '/otpVerification',
    },
    {
      path: '/appshare',
      name: 'AppShare',
      component: AppShare,
    },
    {
      path: '/survey',
      name: 'SurveyLanding',
      component: SurveyLanding,
    },
    {
      path: '/surveyPage/:userid/:surveyuserqualifierid',
      name: 'SurveyPage',
      component: SurveyPage,
    },
    {
      path: '/anon-candidatesurvey',
      name: 'SurveyPage',
      component: SurveyPage,
    },
    {
      path: '/myreferralslist',
      name: 'MyReferralsList',
      component: MyReferralsList,
      beforeEnter: gaurd,
    },
    {
      path: '/thankyou',
      name: 'ThankYou',
      component: ThankYou,
    },
    {
      path: '/notification',
      name: 'Notification',
      component: Notification,
      beforeEnter: gaurd,
    },
    {
      path: '/forgot-passwordold',
      name: 'ForgotPasswordOld',
      component: ForgotPasswordOld,
    },
    {
      path: '/anonverificationold',
      name: 'VerificationOld',
      component: VerificationOld,
    },
    {
      path: '/errormessage',
      name: 'ErrorMessage',
      component: ErrorMessage,
    },
    {
      path: '/chat',
      name: 'Chat',
      component: ChatLanding,
    },
    {
      path: '/forum',
      name: 'Forum',
      component: Forum,
    },
    {
      path: '/post/:postId',
      name: 'PostDetails',
      component: PostDetails,
      beforeEnter: gaurd,
    },
    {
      path: '/confirmEmailAddrress',
      name: 'ConfirmEmailAddrress',
      component: ConfirmEmailAddrress,
    },
    {
      path: '/confirmPhoneNumber',
      name: 'confirmPhoneNumber',
      component: ConfirmPhoneNumber,
    },
    {
      path: '/unsubscribe',
      name: 'unsubscribe',
      component: Unsubscribe,
    },
    {
      path: '/roleRegisterList',
      name: 'RoleRegisterList',
      component: RoleRegisterList,
    },
    {
      path: '/pilotSignup',
      name: 'PilotSignup',
      component: PilotSignup,
    },
    {
      path: '/engineerSignup',
      name: 'EngineerSignup',
      component: EngineerSignup,
    },
    {
      path: '/otherSignup',
      name: 'OtherSignup',
      component: OtherSignup,
    },
    {
      path: '/timesheet',
      name: 'Timesheet',
      component: Timesheet,
    },
    {
      path: '/account-locked',
      name: 'AccountLocked',
      component: AccountLocked,
    },
  ],
});

const titles = {
  Login: 'Login',
  Signup: 'Sign Up',
  MyProfileDetails: 'Profile',
  AppReferral: 'Referral',
  CompanyReferral: 'Referral',
  ChangePassword: 'Change Password',
  ForgotPassword: 'Forgot Password',
  Myprofile: 'My Profile',
  CompanyProfile: 'Company Profile',
  Findjobs: 'Jobs',
  Jobdetails: 'Job Details',
  JobReferraldetails: 'Referral',
  Joblisting: 'Joblisting',
  Referrals: 'Referrals',
  AnonReferAFriend: 'Refer A Friend',
  ReferAFriend: 'Refer A Friend',
  Verification: 'Verification',
  AnonVerification: 'Verification',
  JobApplicationSuccess: 'Job Application Success',
  Invite: 'Invite',
  JobHistory: 'Job History',
  JobShare: 'JobShare',
  Resumes: 'Resume',
  Skills: 'Skills',
  ResumeUpload: 'Resume Upload',
  Questionnaire: 'Questionnaire',
  SupportingDocuments: 'Supporting Documents',
  WLReferralMain: 'Referral',
  AppShare: 'AppShare',
  Notification: 'Notification',
  MyReferralsList: 'My Referrals List',
};

router.afterEach((to: any, from) => {
  const candidatePortalTitle = vxm.utility.CandidatePortalTitle;
  const routePageTitle =
    titles[to.name] !== undefined ? titles[to.name] : 'Talent Portal';
  document.title = routePageTitle + ' | ' + candidatePortalTitle;
  const metaTag: any = document.querySelector('meta[name="description"]');
  metaTag.setAttribute(
    'content',
    'Search, apply, and refer jobs in your area.',
  );
  vxm.utility.setCanShowHeaderLinks(to.name !== 'GuidedSignup');
});
export default router;
